import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Select, MenuItem, FormControl, InputLabel } from "@mui/material";

const ChangeLanguageDropdown = () => {
  const { i18n } = useTranslation();
  const [language, setLanguage] = useState(i18n.language || "en");

  const handleChange = (event) => {
    const selectedLang = event.target.value;
    setLanguage(selectedLang);
    i18n.changeLanguage(selectedLang) // This should work now
      .then(() => {
        console.log(`Language changed to ${selectedLang}`);
      })
      .catch((err) => {
        console.error("Error changing language:", err);
      });
    localStorage.setItem("i18nextLng", selectedLang);
  };

  return (
    <FormControl variant="outlined" size="small">
      <InputLabel id="language-select-label">Language</InputLabel>
      <Select
        labelId="language-select-label"
        value={language}
        label="Language"
        onChange={handleChange}
        style={{ minWidth: 120 }}
      >
        <MenuItem value="cn">华语</MenuItem>
        <MenuItem value="en">English</MenuItem>
      </Select>
    </FormControl>
  );
};

export default ChangeLanguageDropdown;